import { component } from 'picoapp';
import Marquee3k from 'marquee3000';

export default component((node, ctx) => {
  const recent = node.querySelector('.js-recent-creations');
  if (!recent) {
    console.log('marquee marquee');
    Marquee3k.init({
      selector: 'scroller',
    });
  }
});
